import React, {useCallback, useContext, useEffect, useState} from "react";
import {loadDataWithCache} from "../../utils";
import Image from "../../components/Gallery/components/Image/Image";
import './style.scss';
import {ProjectsContext} from "../../App";

function Contact () {
    const {imagesCache, setImagesCache} = useContext(ProjectsContext);
    const [formData, setFormData] = useState({name:'', email:'', message:''});
    const [image, setImage] = useState()
    const encode = (data) => {
        return Object.keys(data)
            .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
            .join("&");
    }
    const handleChange = e => {
        setFormData({...formData, [e.target.name]: e.target.value})
    };

    const handleSubmit = e => {
        e.preventDefault();

        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: encode({ "form-name": "contactUs", ...formData }),
        })
            .then(() => {
                alert(`Thank you, ${formData.name} for your submission`);
                setFormData({name:'', email:'', message:''});
            })
            .catch((error) => alert(error));
    };

    const getData = useCallback(async () => {
        const res = await loadDataWithCache('contact', imagesCache, setImagesCache);
        setImage(res);
    }, [imagesCache, setImagesCache]);


    useEffect(() => {
        getData();
    },[getData])

    return (
        <div>
            <h1>Contact</h1>
            <div className='contact-page'>
                {image && <Image src={image[0].public_id}/>} 
                <form name="contactUs" method="POST" data-netlify="true" netlify-honeypot="bot-field" onSubmit={handleSubmit}>
                    <input type="hidden" name="contactUs" value="contactUs" />
                    <input type="hidden" name="bot-field" value="bot-field" />
                    <p>
                        <label>Name:</label>
                        <label><input type="text" name="name" value={formData.name} onChange={(e) => handleChange(e)} tabIndex="1" required/></label>
                    </p>
                    <p>
                        <label>Email:</label>
                    <label><input type="email" name="email" value={formData.email} onChange={(e) => handleChange(e)} tabIndex="2" required/></label>
                    </p>
                    <p>
                        <label>Message: </label>
                        <label><textarea name="message" value={formData.message} placeholder="Say something…" onChange={(e) => handleChange(e)} tabIndex="3" required></textarea></label>
                    </p>
                    <p>
                        <button type="submit" tabIndex="4">Send</button>
                    </p>
                </form>
            </div>
        </div>
    );
}

export default Contact;
